export default {
  'app.member': 'สิทธิ์สมาชิก',
  'app.member.management': 'การจัดการสมาชิก',
  'app.member.management.search': 'ตัวกรองการค้นหา',
  'app.member.management.invite': 'เชิญสมาชิกทีม',
  'app.member.management.invite.sso.tip':
    'องค์กรได้เปิดใช้งาน SSO การเข้าสู่ระบบ สมาชิกที่ไม่ได้รับบทบาทจะถูกมอบบทบาทด้วยค่าเริ่มต้น คุณสามารถแก้ไขบทบาทหลังจากที่สมาชิกเข้าร่วม',
  'app.member.management.invite.edit': 'แก้ไขสมาชิก',
  'app.member.management.invite.name.first': 'ชื่อ',
  'app.member.management.invite.name.first.placeholder': 'กรุณากรอกชื่อ',
  'app.member.management.invite.name.first.validate': 'กรุณากรอกชื่อ',
  'app.member.management.invite.name.last': 'นามสกุล',
  'app.member.management.invite.name.last.placeholder': 'กรุณากรอกนามสกุล',
  'app.member.management.invite.name.last.validate': 'กรุณากรอกนามสกุล',
  'app.member.management.invite.email': 'อีเมล',
  'app.member.management.invite.email.placeholder': 'กรุณากรอกอีเมล',
  'app.member.management.invite.email.validate.empty': 'กรุณากรอกอีเมล',
  'app.member.management.invite.email.validate.right': 'กรุณากรอกอีเมล',
  'app.member.management.invite.ssoConfig': 'บริการ SSO ขององค์กร',
  'app.member.management.invite.ssoConfig.placeholder': 'เลือกบริการ SSO ขององค์กร',
  'app.member.management.invite.ssoConfig.validate': 'กรุณาเลือกบริการ SSO ขององค์กร',
  'app.member.management.invite.role': 'บทบาท',
  'app.member.management.invite.role.placeholder': 'เลือกบทบาทในองค์กร และเชิญสมาชิก',
  'app.member.management.invite.role.empty': 'ไม่มีบทบาท',
  'app.member.management.invite.role.create': 'เพิ่มบทบาท',
  'app.member.management.invite.role.validate': 'กรุณาเลือกบทบาทในองค์กร และเชิญสมาชิก',
  'app.member.management.invite.ok': 'ยืนยัน',
  'app.member.management.invite.cancel': 'ยกเลิก',
  'app.member.management.table.name': 'ชื่อบัญชี',
  'app.member.management.table.id': 'ไอดีบัญชี',
  'app.member.management.table.status': 'สถานะบัญชี',
  'app.member.management.table.status.enable': 'เปิดใช้งาน',
  'app.member.management.table.status.disable': 'ปิดใช้งาน',
  'app.member.management.table.status.wait': 'รอเข้าร่วม',
  'app.member.management.table.time.last': 'เวลาเยี่ยมชมล่าสุด',
  'app.member.management.table.time.create': 'เวลาสร้าง',
  'app.member.management.table.operation': 'ดำเนินการ',
  'app.member.management.table.operation.detail': 'รายละเอียด',
  'app.member.management.table.operation.edit': 'แก้ไข',
  'app.member.management.table.operation.resend': 'ขอรหัสยืนยันใหม่',
  'app.member.management.table.operation.disable': 'ปิดใช้งาน',
  'app.member.management.table.operation.enable': 'เปิดใช้งาน',
  'app.member.management.table.operation.delete': 'ลบ',
  'app.member.management.table.operation.delete.confirm': 'บัญชีไม่สามารถใช้งานได้หลังจากการลบ',
  'app.member.management.table.operation.delete.confirm.ok': 'ยืนยัน',
  'app.member.management.table.operation.delete.confirm.cancel': 'ยกเลิก',
  'app.member.management.table.operation.invite.success': 'เชิญสำเร็จ',
  'app.member.role': 'การจัดการบทบาท',
  'app.member.role.create': 'สร้างบทบาท',
  'app.member.role.edit': 'แก้ไขบทบาท',
  'app.member.role.create.placeholder': 'ใส่ชื่อบทบาท',
  'app.member.role.admin': 'ผู้ดูแลระบบ',
  'app.member.role.rights': 'สิทธิ์',
  'app.member.role.members': 'สมาชิก',
  'app.member.role.name.placeholder': 'ใส่ชื่อบทบาท',
  'app.member.role.creater': 'สร้างโดย',
  'app.member.role.creater.validate': 'โปรดใส่ชื่อผู้ใช้ของคุณ',
  'app.member.role.console': 'คอนโซล',
  'app.member.role.empty': 'ว่างเปล่า',
  'app.member.role.tip':
    'บทบาทโกลบอลเป็นบทบาทที่ตั้งไว้ตั้งแต่เริ่มต้นของแต่ละโครงการโดยค่าเริ่มต้น',
  'app.member.role.submit': 'ตั้งค่าสำเร็จแล้ว!',
  'app.member.role.save': 'บันทึกสำเร็จแล้ว!',
  'app.member.role.delete':
    'หลังจากลบบทบาท สิทธิ์สมาชิกที่เกี่ยวข้องกับบทบาทนั้นจะไม่สามารถใช้งานได้อีก',
  'app.member.role.delete.ok': 'ลบ',
  'app.member.role.delete.cancel': 'ยกเลิก',
  'app.member.role.members.table.search': 'ตัวกรองการค้นหา',
  'app.member.role.members.table.name': 'ชื่อบัญชี',
  'app.member.role.members.table.id': 'รหัสบัญชี',
  'app.member.role.members.table.emial': 'อีเมล',
  'app.member.role.members.table.status': 'สถานะบัญชี',
  'app.member.role.members.table.status.enable': 'เปิดใช้งาน',
  'app.member.role.members.table.status.disable': 'ปิดใช้งาน',
  'app.member.role.members.table.status.wait': 'รอการเข้าร่วม',
  'app.member.role.members.table.time.last': 'เวลาเข้าชมล่าสุด',
  'app.member.role.members.table.time.create': 'เวลาสร้าง',
  'app.member.role.members.table.operation': 'การดำเนินการ',
  'app.member.role.members.table.operation.detail': 'รายละเอียด',
  'app.member.role.members.table.operation.detail.title': 'รายละเอียดสมาชิก',
  'app.member.role.members.table.operation.detail.permission': 'รายละเอียดสิทธิ์',
  'app.member.role.members.table.operation.delete': 'ลบบทบาท',
  'app.member.role.permission.sharing': 'แอปทั้งหมดแบ่งปันสิทธิ์บทบาท',
  'app.member.role.permission.sharing.tip':
    'หลังจากติ๊กแล้วบันทึกสิทธิ์ที่บทบาทนี้มีอยู่จะสอดคล้องกันในแอปพลิเคชันทั้งหมด',
  'app.member.management.create.org': 'ไม่ว่าจะเป็นการเปิดให้สมาชิกสร้างองค์กร',
  'app.member.management.create.yes': 'ใช่',
  'app.member.management.create.no': 'ไม่',
  'app.member.roleCopy.copy': 'คัดลอกบทบาท',
  'app.member.roleCopy.title': 'คัดลอกบทบาทไปยังองค์กรอื่น',
  'app.member.roleCopy.select': 'เลือกองค์กร',
  'app.member.roleCopy.selectTip': 'กรุณาเลือกองค์กร',
  'app.member.roleCopy.all': 'เลือกทั้งหมด',
  'app.member.roleCopy.success': 'คัดลอกสำเร็จ!',
  'app.member.role.otp.target.tip': `<p>1）เมื่อเป้าหมายเป็นหมายเลขโทรศัพท์：</p>
    <p>เมื่อเจ้าหน้าที่ไม่มีสิทธิ์ดูเป้าหมาย หมายเลขที่เห็นในประวัติจะเป็นหมายเลขที่ถูกปิดบังข้อมูล เมื่อหมายเลขถูกปิดบังข้อมูล จะแสดงเฉพาะ 3 ตัวอักษรแรกและ 2 ตัวอักษรสุดท้ายของหมายเลขเท่านั้น。</p>
    <p>2）เมื่อเป้าหมายเป็นอีเมล：</p>
    <p>จะแสดงเพียง 2 ตัวอักษรแรก และที่อยู่อีเมลหลังเครื่องหมาย {'@'} จะยังคงไม่เปลี่ยนแปลง。</p>
    <p>ตัวอย่าง：</p>
    <p>otpsupport{'@'}engagelab.com</p>
    <p>หลังจากปิดบังข้อมูล จะแสดงเป็น：</p>
    <p>ot***{'@'}engagelab.com</p>
    `,
};
